import { Resource } from '@modules/centers/interfaces/resource';
import TableHeader from '@shared/components/tables/table-header/table-header.vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import FullCalendar, { CalendarOptions, EventApi, DateSelectArg } from '@fullcalendar/vue';
// import { Calendar } from '@fullcalendar/core';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import scrollGrid from '@fullcalendar/scrollgrid';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import { BookingEvent } from '@bookings/interfaces/booking-event';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import TableFooter from '@shared/components/tables/table-footer/table-footer.vue';
import { Discipline } from '@centers/interfaces/discipline';
import moment from 'moment';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import { set } from 'lodash';
import { Booking } from '@bookings/interfaces/booking';
import StdxForm from '@shared/components/forms/auto-form/stdx-form/stdx-form.vue';
import VuexFormProvider from '@shared/components/forms/auto-form/vuex-form-provider/vuex-form-provider';
import { Calendar } from '@fullcalendar/core';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';
import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import tippy from 'tippy.js';
import allLocales from '@fullcalendar/core/locales-all';

@Component({
  name: 'bpc-booking-event-weekly-calendar-public',
  components: {
    'full-calendar': FullCalendar,
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-table-header': TableHeader,
    'bpc-table-footer': TableFooter,
    'bpc-page-title': BpcPageTitle,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-entity-select': EntitySelect,
    'bpc-select': Select,
    'bpc-stdx-form': StdxForm,
    'bpc-std-filter': StdFilter,
  },
})
export default class BookingEventWeeklyCalendarPublic extends mixins(AbstractTable) {
  $refs: AbstractTable['$refs'] & {
    eventForm: InstanceType<typeof StdxForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: VuexFormProvider;
    };
    fcalendar: InstanceType<typeof FullCalendar> & {
      $emit(event): void;
      getApi(): Calendar;
    };
  };

  @Prop({ type: [Number, String], default: null }) readonly tenant_id: number | string;
  @Prop({ type: Number, default: null }) readonly calendarResourceId: number;
  @Prop({ type: Boolean, default: false }) readonly calendarHideFilters: boolean;

  public entity: Booking = null;
  public isLogged: boolean = false;

  public resourcesLoaded: boolean = false;
  public resources: Resource[] = [];

  public disciplinesLoaded: boolean = false;
  public disciplines: Discipline[] = [];
  public selectedDisciplineId: number = null;

  public items: BookingEvent[] = [];
  public allEvents: any[] = [];

  public entityName = 'booking-event';
  public pluralEntityName = 'booking-events';
  public permissionEntityNameToUse = 'bookings';

  public customPageActions = {};
  public customRowActions = {};

  public stdFilterModel = {
    date: null,
    resource__sectors__id: null,
    discipline__id: null,
    resource_id: null,
    weekday: null,
  };

  public resourcesSelectInfo = [];

  public showEventDrawerSection = false;
  public showEventForm = false;
  public bookingEvent: BookingEvent = null;

  public isSimpleBooking = true;
  public headingDate: string = '';

  public showPageTitle: boolean = true;
  public showSectors: boolean = false;
  public showSlotPrices: boolean = false;
  public hideHeading: boolean = false;
  public hideFilters: boolean = false;

  constructor() {
    super();
  }

  public get selectedDiscipline(): Discipline {
    return this.disciplines.find(discipline => discipline.id === this.selectedDisciplineId);
  }

  get startLoadingEntities(): boolean {
    return this.$store.getters[`${this.storeName}/loadingEntities`](this.entityName);
  }

  get language(): string {
    return localStorage.getItem('lang') ? localStorage.getItem('lang') : navigator.language;
  }

  onEventFormSave() {
    this.isSavingForm = true;
    this.allEvents = [];
    this.nextAction = '';
    this.$refs.eventForm.saveEntity();
  }

  onEventFormClose() {
    this.showEventForm = false;
    this.showEventDrawerSection = false;
  }

  public get filterDate(): string {
    return this.stdFilterModel.weekday || moment().format('YYYY-MM-DD');
  }

  public get selectedSectorId(): number {
    return this.stdFilterModel.resource__sectors__id || null;
  }

  public get filterResourceId(): number {
    return this.filterModel?.resource_id ? this.filterModel.resource_id : this.calendarResourceId;
  }

  public get slotMinTime() {
    return this.$store.getters['centerSettings/centerSettings'].default_start_hour;
  }

  public get slotMaxTime() {
    return this.$store.getters['centerSettings/centerSettings'].default_end_hour;
  }

  public get defaultSlotDuration() {
    const slotDuration = this.$store.getters['centerSettings/centerSettings'].default_slot_duration;
    const hours = Math.floor(slotDuration / 60);
    const minutes = slotDuration % 60 < 10 ? `0${slotDuration % 60}` : slotDuration % 60;

    return `${hours}:${minutes}:00`;
  }

  public get slotDuration() {
    return this.$store.getters['centerSettings/centerSettings'].default_slot_duration;
  }

  private calendarOptions: CalendarOptions = {
    plugins: [resourceTimeGridPlugin, interactionPlugin, scrollGrid],
    schedulerLicenseKey: process.env.VUE_APP_FULLCALENDAR_LICENCE_KEY,
    headerToolbar: {
      left: '',
      center: '',
      right: '',
    },
    locales: allLocales,
    locale: this.language, // the initial locale
    resources: [],
    resourceLabelDidMount: function(info) {
      tippy(info.el, {
        content: info.resource.extendedProps.name,
      });
    },
    initialView: 'timeGridWeek',
    // views: {
    //   resourceTimeGrid: {
    //     type: 'resourceTimeGrid',
    //     duration: { days: 7 },
    //   },
    // },
    initialEvents: 'events', // alternatively, use the `events` setting to fetch from a feed
    initialDate: this.filterDate,
    viewDidMount: this.gotoCurrentDate,
    editable: false,
    selectable: false,
    selectMirror: true,
    dayMaxEvents: true,
    weekends: true,
    unselectAuto: false,
    select: this.handleDateSelect,
    selectOverlap: this.handleConflictEvents,
    // eventClick: this.handleEventChange,
    eventsSet: this.handleEvents,
    eventDrop: this.dragAndDropEventChange,
    eventOverlap: false,
    datesAboveResources: true,
    dayMinWidth: 100,
    allDaySlot: false,
    slotMinTime: this.slotMinTime,
    slotMaxTime: this.slotMaxTime,
    eventTimeFormat: {
      hour: '2-digit',
      minute: '2-digit',
      omitZeroMinute: false,
      hour12: false,
      meridiem: false,
    },
    slotLabelFormat: {
      hour: '2-digit',
      minute: '2-digit',
      omitZeroMinute: false,
      hour12: false,
      meridiem: false,
    },
    slotDuration: this.defaultSlotDuration,
    height: 'auto',
    stickyHeaderDates: 'auto',
    nowIndicator: true,
    weekNumberCalculation: 'ISO',
    // eventChange: this.handleEventChange,
    /* you can update a remote database when these fire:
    eventAdd:
    eventChange:
    eventRemove:
    */
  };
  public currentEvents: EventApi[] = [];

  private dragAndDropEvent: any = null;

  getUpdateEventConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: 'update-event-confirmation-modal',
      title: this.$t('global.modals.update-booking-event.title') as string,
      body: this.$t('global.modals.update-booking-event.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
      acceptButtonVariant: 'info',
    };
  }

  dragAndDropEventChange(e) {
    this.dragAndDropEvent = e;
    this.bookingEvent = this.items.find(event => event.id === Number(e.event.id));

    const start = moment(e.event.start);
    const end = moment(e.event.end);
    const resourceId = e.event.getResources()[0] ? e.event.getResources()[0].id : null;

    this.bookingEvent.start_time = start.format('HH:mm');
    this.bookingEvent.end_time = end.format('HH:mm');
    this.bookingEvent.date = start.format('YYYY-MM-DD');
    this.bookingEvent.resource_id = resourceId;

    this.$bvModal.show('update-event-confirmation-modal');
  }

  onCancelUpdateEventModal() {
    this.dragAndDropEvent.revert();
    this.dragAndDropEvent = null;
  }

  onConfirmUpdateEventModal(e) {
    const updateEventObservable: Observable<BPCGenericApiResponse> = this.$bpcApi.put(
      `${this.$bpcApiRouteHelper.getEntityPath('booking-event')}/${this.bookingEvent.id}`,
      this.bookingEvent,
      null,
    );

    updateEventObservable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
        this.$refs.provider.getEntities();
      },
      error => {
        this.$bvModal.hide('update-event-confirmation-modal');
        this.bookingEvent = null;
        this.$bpcMessage.showErrorMessage({ text: 'global.generic.error_update_action' });
      },
      () => {
        this.bookingEvent = null;
        this.$bvModal.hide('update-event-confirmation-modal');
        this.allEvents = this.$refs.provider.items;
      },
    );
  }

  handleEventChange(e) {
    this.showForm = false;
    this.showDrawerSection = false;
    this.showEventForm = true;
    this.showEventDrawerSection = true;
    this.currentAction = 'edit'; // To indicate that we are not in the search of booking
    const event = this.items.find(event => event.id === Number(e.event.id));

    if (event) {
      this.bookingEvent = event;
    }

    this.$store
      .dispatch(`bookingEvent/initializeFormModel`, {
        entity: 'booking-event',
        fetchEntity: this.bookingEvent ? true : false,
        id: this.bookingEvent.id,
        formName: 'default',
      })
      .then(res => {
        res.add(() => {
          setTimeout(() => {
            const start = moment(e.event.start);
            const end = moment(e.event.end);

            this.$store.commit('bookingEvent/setModelProp', {
              prop: 'start_time',
              value: start.format('HH:mm'),
            });

            this.$store.commit('bookingEvent/setModelProp', {
              prop: 'end_time',
              value: end.format('HH:mm'),
            });

            this.$store.commit('bookingEvent/setModelProp', {
              prop: 'date',
              value: start.format('YYYY-MM-DD'),
            });

            const resourceId = e.event.getResources()[0] ? e.event.getResources()[0].id : null;

            if (resourceId) {
              const resource = this.resources.find(resource => resource.id === Number(resourceId));
              this.$store.commit('bookingEvent/setModelProp', {
                prop: 'resource',
                value: resource,
              });

              this.$store.commit('bookingEvent/setModelProp', {
                prop: 'resource_id',
                value: resourceId,
              });
            }

            // this.$store.commit('booking/setModel', model);
          }, 1000);
        });
      });
  }
  handleDateSelect(selectInfo: DateSelectArg) {
    this.showEventDrawerSection = false;
    this.showEventForm = false;
    this.showForm = true;
    this.showDrawerSection = true;

    setTimeout(() => {
      this.$store.commit(`booking/setInitialModel`, {
        fields: this.$store.getters[`booking/fieldsObject`],
        model: {},
      });

      this.currentAction = 'new'; // To indicate that we are not in the search of booking

      // this.onNew();
      const start = moment(selectInfo.startStr);
      const end = moment(selectInfo.endStr);
      const model = this.$store.getters['booking/model'];
      const resource = this.resources.find(
        resource => resource.id === Number(selectInfo.resource.id),
      );

      set(model, 'time_range.start_time', start.format('HH:mm'));
      set(model, 'start_date', start.format('YYYY-MM-DD'));
      set(model, 'time_range.end_time', end.format('HH:mm'));

      if (resource) {
        set(model, 'resources', [resource]);
      }

      this.$store.commit('booking/setModel', model);
    }, 1000);
  }
  handleConflictEvents(e) {
    const res = e.className !== 'excluded-event';
    if (!res) {
      this.$bpcMessage.showErrorMessage({ text: 'bookings.exclusion_error' });
    }
    return res;
  }

  onEventFormSaved() {
    this.allEvents = [];
    this.onEventFormClose();
    this.$refs.provider.getEntities();
  }

  onFormSave() {
    this.isSavingForm = true;
    this.allEvents = [];
    this.nextAction = '';
    this.$refs.stdForm.saveEntity();
  }

  handleEvents(events: EventApi[]) {
    this.currentEvents = events;
  }

  onNew() {
    this.entity = null;
    this.$bpcStorage.clear('booking-events');
    this.isSimpleBooking = true;
    this.showForm = true;
    // this.$bvModal.show('modal-resource-form');
    this.showDrawerSection = true;
  }

  onFormSearch() {
    this.isSavingForm = true;
    this.$refs.stdForm.searchEntity();
    this.resourcesSelectInfo = [];
    this.$bpcStorage.clear('booking-events');
  }

  getResources() {
    this.resourcesLoaded = false;

    const params = {
      per_page: 500,
      orderBy: 'ordering',
      orderDirection: 'asc',
    };

    if (this.selectedSectorId) {
      params['sectors__id'] = this.selectedSectorId;
    }

    if (this.selectedDisciplineId) {
      params['disciplines__id'] = this.selectedDisciplineId;
    }

    if (this.$route.query.resource_id) {
      params['id'] = this.$route.query.resource_id;
    }

    if (this.calendarResourceId) {
      params['id'] = this.calendarResourceId;
    }

    this.$bpcApi
      .get(this.$bpcApiRouteHelper.getEntityPath('resource'), {
        params: params,
      })
      .subscribe(res => {
        this.resources = res.data;
        this.$set(this.calendarOptions, 'resources', this.parseResources(this.resources));
        this.resourcesLoaded = true;
        this.getDisciplines();
      });
  }

  getDisciplines() {
    const params = { per_page: 500 };
    params['resources__id'] = this.resources.map(resource => {
      return resource.id;
    });

    this.$bpcApi
      .get(this.$bpcApiRouteHelper.getEntityPath('discipline'), {
        params: params,
      })
      .subscribe(res => {
        this.disciplines = res.data;
      });
  }

  parseResources(resources: Resource[]) {
    return resources.map(resource => {
      return {
        id: `${resource.id}`,
        title: resource.code,
        name: resource.name,
      };
    });
  }

  selectDiscipline(id: number): void {
    this.selectedDisciplineId = id;
    this.getResources();
  }

  getSlotPricesCategories() {
    const params = this.$refs.provider.queryConfig.params;
    this.$bpcApi
      .get(this.$bpcApiRouteHelper.getEntityPath('schedule-slot-ranges') + '/ranges-by-week', {
        params,
      })
      .subscribe(res => {
        const slots = res.data.map(slot => {
          return {
            start: this.formatDateTime(slot.date, slot.start_time),
            end: this.formatDateTime(slot.date, slot.end_time),
            backgroundColor: `${slot.color}`,
            borderColor: `${slot.color}`,
            display: 'background',
          };
        });

        if (this.filterResourceId !== null) {
          this.allEvents = this.allEvents.concat(slots);
          this.$set(this.calendarOptions, 'events', this.allEvents);
        } else {
          this.allEvents = [];
          this.$set(this.calendarOptions, 'events', this.allEvents);
        }

        if (this.$refs.fcalendar) {
          this.$refs.fcalendar.$emit('rerender-events');
        }
      });
  }

  getResourceConflicts() {
    const params = this.$refs.provider.queryConfig.params;
    this.$bpcApi
      .get(this.$bpcApiRouteHelper.getEntityPath('booking-event') + '/resource-conflicts/weekly', {
        params,
      })
      .subscribe(res => {
        const excludedEvents = res.data.map(excludedEvent => {
          return {
            id: excludedEvent.id,
            title: excludedEvent.name,
            start: this.formatDateTime(excludedEvent.date, excludedEvent.start_time),
            end: this.formatDateTime(excludedEvent.date, excludedEvent.end_time),
            backgroundColor: '#cecece',
            borderColor: '#cecece',
            resourceId: `${excludedEvent.resource_id}`,
            className: 'excluded-event',
            display: 'background',
          };
        });
        this.allEvents = this.allEvents.concat(excludedEvents);
        this.$set(this.calendarOptions, 'events', this.allEvents);
        if (this.$refs.fcalendar) {
          this.$refs.fcalendar.$emit('rerender-events');
        }
      });
  }

  addEventsToCalendar() {
    this.items = this.$refs.provider ? this.$refs.provider.items : null;
    if (this.calendarResourceId) {
      this.items = this.items.filter(event => event.resource_id === this.calendarResourceId);
    }
    const events = this.items.map(event => {
      return {
        id: event.id,
        title: '',
        start: this.formatDateTime(event.date, event.start_time),
        end: this.formatDateTime(event.date, event.end_time),
        backgroundColor: event['discipline'] ? event['discipline']['color'] : null,
        borderColor: event['discipline'] ? event['discipline']['color'] : null,
        resourceId: `${event.resource_id}`,
      };
    });
    if (this.filterResourceId !== null || this.calendarResourceId) {
      this.allEvents = this.allEvents.concat(events);
      this.$set(this.calendarOptions, 'events', this.allEvents);
    } else {
      this.allEvents = [];
      this.$set(this.calendarOptions, 'events', this.allEvents);
    }

    if (this.$refs.fcalendar) {
      this.$refs.fcalendar.$emit('rerender-events');
    }
    // this.calendarOptions.eventsSet;
  }

  gotoCurrentDate() {
    if (this.$refs.fcalendar) {
      this.$refs.fcalendar.getApi().gotoDate(this.filterDate);
    }
  }

  formatDateTime(date, time): string {
    return moment(`${date} ${time}`).toISOString();
  }

  hasBookingEvents(): boolean {
    return this.isSimpleBooking ? false : !!this.$store.getters['booking/model'].bookingEvents;
  }

  onFormSearched() {
    this.currentAction = 'search'; // To indicate that we are not in the search of booking
  }

  syncDateFilterModel(model) {
    if (model) {
      this.updateHeadingDate(model.weekday);
      this.$set(this.stdFilterModel, 'weekday', model.weekday || null);
    }
  }

  syncSectorFilterModel(model) {
    if (model) {
      this.$set(this.stdFilterModel, 'resource__sectors__id', model.resource__sectors__id || null);
    }
  }

  updateHeadingDate(date) {
    this.headingDate = '';
    if (date) {
      const start = moment(date)
        .lang(this.language)
        .startOf('isoWeek')
        .format('dddd DD/MM/YYYY')
        .toUpperCase();
      const end = moment(date)
        .lang(this.language)
        .endOf('isoWeek')
        .format('dddd DD/MM/YYYY')
        .toUpperCase();

      this.headingDate = `${start} - ${end}`;
    }
  }

  checkRouteQueryParams() {
    const query = this.$route.query;
    if ('showPageTitle' in query && query.showPageTitle !== 'true') {
      this.showPageTitle = false;
    }

    if ('showSectors' in query && query.showSectors === 'true') {
      this.showSectors = true;
    }

    if ('showSlotPrices' in query && query.showSlotPrices === 'true') {
      this.showSlotPrices = true;
    }

    if ('hideHeading' in query && query.hideHeading === 'true') {
      this.hideHeading = true;
    }
  }

  checkRouteQueryParamsOnCreated() {
    const query = this.$route.query;
    if ('hideFilters' in query && query.hideFilters === 'true') {
      this.hideFilters = true;
    }
    if (this.calendarHideFilters) {
      this.hideFilters = true;
    }
  }

  onChangeFilter() {
    if (
      this.$refs.provider &&
      this.$refs.provider.canLoadEntities &&
      this.$refs.provider.firstLoadEntities
    ) {
      let changed = false;
      changed = this.setQueryConfigParams();
      if (changed) {
        // Only do the request if there was a change in the filters (to avoid duplicate request in the initialization of the filter component)
        this.$router.push({ query: this.$refs.provider.queryConfig.params }).catch(e => {
          return null;
        });

        if (this.filterResourceId !== null) {
          this.$refs.provider.getEntities();
        } else {
          this.allEvents = [];
          this.$set(this.calendarOptions, 'events', this.allEvents);
          if (this.$refs.fcalendar) {
            this.$refs.fcalendar.$emit('rerender-events');
          }
        }

        this.updatePageActions();
        this.updateRowActions();
        if (this.$refs.fcalendar) {
          this.$refs.fcalendar.$emit('rerender-events');
        }
      }
    }
  }

  /* Lifecycle hooks */

  created() {
    this.checkRouteQueryParamsOnCreated();
    this.getResources();
  }

  mounted() {
    this.checkRouteQueryParams();
    this.$bpcEcho.listenUpdateCenterSettings();
  }
  // updated () { }
  destroyed() {
    this.$bpcEcho.leaveUpdateCenterSettings();
  }

  @Watch('filterDate')
  onChangeFilterDate() {
    this.allEvents = [];
    this.gotoCurrentDate();
  }

  @Watch('selectedSectorId')
  onChangeSelectedSectorId() {
    this.allEvents = [];
    this.getResources();
  }

  @Watch('selectedDisciplineId')
  onChangeSelectedDisciplineId(val) {
    this.allEvents = [];
    this.selectDiscipline(val);
  }

  @Watch('startLoadingEntities')
  onStartLoadingEntities() {
    if (this.startLoadingEntities === true) {
      this.getResourceConflicts();
      if (this.showSlotPrices) {
        this.getSlotPricesCategories();
      }
    }
  }

  @Watch('filterResourceId')
  onChangeFilterResource() {
    if (
      this.$refs.provider &&
      this.$refs.provider.canLoadEntities &&
      this.$refs.provider.firstLoadEntities
    ) {
      this.allEvents = [];
      this.getResources();
    }
  }

  @Watch('slotMinTime')
  onChangeSlotMinTime() {
    this.$set(this.calendarOptions, 'slotMinTime', this.slotMinTime);
    if (this.$refs.fcalendar) {
      this.$refs.fcalendar.$emit('render');
    }
  }

  @Watch('slotMaxTime')
  onChangeSlotMaxTime() {
    this.$set(this.calendarOptions, 'slotMaxTime', this.slotMaxTime);
    if (this.$refs.fcalendar) {
      this.$refs.fcalendar.$emit('render');
    }
  }

  @Watch('slotDuration')
  onChangeSlotDuration() {
    const hours = Math.floor(this.slotDuration / 60);
    const minutes =
      this.slotDuration % 60 < 10 ? `0${this.slotDuration % 60}` : this.slotDuration % 60;
    const slotDurationFormated = `${hours}:${minutes}:00`;
    this.$set(this.calendarOptions, 'slotDuration', slotDurationFormated);
    if (this.$refs.fcalendar) {
      this.$refs.fcalendar.$emit('render');
    }
  }
}
